import React, { ReactNode } from 'react';
import { observer } from 'mobx-react-lite';

import { useViewMode } from 'src/hooks';
import { useStore } from '@src/models/RootStore';
import { LayoutBox } from 'src/kit';
import { LogoTiny, LogoBig } from 'src/components';
import { DefaultPrivateRouteLink } from '@src/features/common';
import { StyledHeader } from './Header.styled';
import { DesktopHeader } from './DesktopHeader';
import { MobileHeader } from './MobileHeader';

export const Header = observer(function Header({
  title,
  isLegacy,
  ...props
}: {
  title?: string;
  isLegacy?: boolean;
  search?: ReactNode;
}) {
  const { authStore, userStore } = useStore();
  const { isDesktopMode, isMobileMode } = useViewMode();

  return (
    <StyledHeader className={`${isLegacy ? 'legacy' : ''}`}>
      {isMobileMode && <MobileHeader {...{ authStore, userStore }} {...props} />}
      {isLegacy && (
        <DefaultPrivateRouteLink mr={30}>
          {isMobileMode ? (
            <LayoutBox as={LogoTiny} height={35} width={27} color="header.text" />
          ) : (
            <LogoBig color="white" />
          )}
        </DefaultPrivateRouteLink>
      )}
      {isDesktopMode && <DesktopHeader {...{ title, authStore, userStore }} {...props} />}
    </StyledHeader>
  );
});
